export default __webpack_public_path__ + "static/media/gestion_simplifiee.ed5f3543.svg";